const scrollTop = (scrollY = 0) => (document.querySelector('#pageScrollWrapper').scrollTop = scrollY)

export default scrollTop
